import { i18n_config_default } from './chunk-5FPUWZMY.mjs';

// src/hooks/usePrintJobStatusName.ts
var getPrintJobStatusName = (status) => {
  return i18n_config_default.t(`navBar.common.printerCenter.printJobs.status.${status}`);
};
var usePrintJobStatusName = (status) => {
  return getPrintJobStatusName(status);
};

export { getPrintJobStatusName, usePrintJobStatusName };
